import cn from "classnames";
import { paths } from "helpers/paths";
import React, { useEffect, useState } from "react";
import MapHeader from "./header";
import MainMap from "./mainMap";
import PickerMap from "./pickerMap";
import RelayConnectionBanner from "./relayConnectionBanner";

const MAPS = {
    main: MainMap,
    picker: PickerMap,
};

const miniMapPaths = [
    `${paths.routeTemplates}/list`,
    `${paths.distributionBids}/bid/`,
    `${paths.bid}/bid`,
    `${paths.bid}/rate`,
    paths.adminTrackerLogs,
];

export default function MapSwitch(props) {
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setShouldRender(true);
            const { roles, mergeParams, params } = props;
            const {
                isTruckingOrganizationAdmin,
                isTruckingOrganizationManager,
                isTruckingOrganizationOperator,
                isTruckingOrganizationViewer,
                isTruckingOrganizationDispatcher,
                isTruckingOrganizationExtendedViewer,
            } = roles;
            if (
                isTruckingOrganizationAdmin ||
                isTruckingOrganizationManager ||
                isTruckingOrganizationOperator ||
                isTruckingOrganizationViewer ||
                isTruckingOrganizationDispatcher ||
                isTruckingOrganizationExtendedViewer
            ) {
                mergeParams(params);
            }
        }, 800);
        return () => clearTimeout(timeoutId);
    }, []);

    const renderBody = () => {
        const { mode, header, ...rest } = props;
        const CurrentMap = MAPS[mode];
        const isMini = miniMapPaths.some((item) => rest.location.pathname.includes(item));
        const cname = cn("page-layout__map-container map", { "page-layout__map-container--mini": isMini });
        return (
            <div id="map" className={cname} data-onboarding="bid-route-map">
                <MapHeader {...header} />
                <RelayConnectionBanner {...rest} />
                <CurrentMap {...rest} />
            </div>
        );
    };

    return shouldRender ? renderBody() : <div />;
}
